import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X, ExternalLink } from 'lucide-react';

interface VoteModalProps { isOpen: boolean; onClose: () => void; }

export default function VoteModal({ isOpen, onClose }: VoteModalProps) {
  const dialog = useRef<HTMLDialogElement>(null);
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    if (!isOpen) return;
    dialog.current?.showModal();
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = originalOverflow; };
  }, [isOpen]);
  const handleVote = (event: React.FormEvent) => {
    event.preventDefault();
    if (!username.trim()) { setError('Please enter your username'); return; }
    if (username.length < 4) { setError('Username must be at least 4 characters'); return; }
    window.open(`https://gtop100.com/MapleStory/server-${process.env.REACT_APP_GTOP100_SITE_ID}?vote=1&pingUsername=${encodeURIComponent(username)}`, '_blank', 'noopener,noreferrer');
    setUsername(''); setError(''); onClose();
  };
  if (!isOpen) return null;
  return createPortal(<dialog ref={dialog} className="d-vote-dialog" aria-labelledby="vote-title" onCancel={e=>{e.preventDefault();onClose();}} onClick={e=>{if(e.target===dialog.current)onClose();}}>
    <button className="d-vote-close" aria-label="Close voting" onClick={onClose}><X size={22}/></button>
    <h2 id="vote-title">Vote for Daruma</h2><p>Enter your username to open the voting page.</p>
    <form onSubmit={handleVote}><label htmlFor="vote-username">Username</label><input autoFocus id="vote-username" value={username} onChange={e=>{setUsername(e.target.value);setError('');}} placeholder="Your username" aria-invalid={!!error} aria-describedby={error?'vote-error':undefined}/>{error&&<p id="vote-error" role="alert">{error}</p>}<button className="d-button d-button-primary" type="submit">Open voting page <ExternalLink size={16}/></button></form>
  </dialog>,document.body);
}
